import { createRouter, createWebHistory } from 'vue-router'
import domains from '../Global/utilities/domains.js'

let routes = []

domains.forEach((route) => {
  const domainRoutes = require(`../${route}/routes.js`)
  routes = routes.concat(domainRoutes.default)
})

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// TODO: Remove when no longer needed
router.beforeEach((to, from) => {
  const isEmbedSite = process.env.VUE_APP_IS_EMBED_SITE ? process.env.VUE_APP_IS_EMBED_SITE : false
  if (!to.matched[0].path.includes('/client') && !to.matched[0].path.includes('/error') && isEmbedSite) {
    return { name: 'error404' }
  }
})

router.afterEach((to, from) => {
  if (typeof to.meta?.title !== 'undefined') {
    document.title = to.meta.title
  }
})

export default router
